import styled from 'styled-components';

export const LegendList = styled.div`
  display: flex;
  align-items: center;
  margin: 0 auto;
  width: fit-content;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  margin-right: 15px;
`;

interface LegendColorPropsType {
  $color: string;
  $colorRadius: string;
}

export const LegendColor = styled.div<LegendColorPropsType>`
  background-color: ${(props) => props.$color};
  width: 12px;
  height: 12px;
  min-width: 12px;
  min-height: 12px;
  border-radius: ${(props) => props.$colorRadius};
  margin-right: 3px;
`;

export const LegendValue = styled.div`
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
